export default {
	// Config
	apiKey: "AIzaSyDNYhUbnz3k2qPZBQ7Tz_TC9g-Oe_dESTY",
  authDomain: "luigioil-mytrace.firebaseapp.com",
  projectId: "luigioil-mytrace",
  storageBucket: "luigioil-mytrace.firebasestorage.app",
  messagingSenderId: "844044283305",
  appId: "1:844044283305:web:283feb2c4b22505011e8b8"
};
